import React from 'react'
import PropTypes from 'prop-types'

import { Provider } from 'react-redux'
import { createStore } from 'redux'

import VisitSubForms from './VisitSubforms'

class VisitApp extends React.Component {
  storeState = (
    state = {
      edit: this.props.edit,
      visitTypes: this.props.visitTypes,
      selectedVisitType: this.props.selectedVisitType,
      paymentTypes: this.props.paymentTypes,
      lineItems: this.initializeLineItems(this.props.products, this.props.lineItems, this.props.selectedVisitType),
      totalValue: "0",
      products: this.props.products,
      visibleProducts: this.determineVisibleProducts(this.props.products, this.props.selectedVisitType),
      defaultDate: this.props.defaultDate,
      selectedPaymentType: this.props.selectedPaymentType
    }, action) => {
    let newState = {}
    let curLineItem = {}
    let lineItemsWithoutCurrent = []
    let newTempStateCLI = {}
    let newLineItem = {}
    let visitType = {}
    let newLineItems = []
    let newVisibleProducts = []

    switch (action.type) {
      case 'CHANGE_LINE_ITEM':
        lineItemsWithoutCurrent = this.getLineItemsWithoutCurrent(state.lineItems, action.lineItemId)
        curLineItem = state.lineItems.filter(el => el.id === action.lineItemId)[0]
        let tempValue = parseInt(action.value)

        if (isNaN(tempValue)) {
          curLineItem[action.field] = "0"
        } else {
          curLineItem[action.field] = tempValue
        }

        newTempStateCLI = {
          ...state,
          lineItems: [...lineItemsWithoutCurrent, curLineItem].sort((a, b) => {
            return a.selectedProduct.name > b.selectedProduct.name ? 1 : -1
          })
        }
        newTempStateCLI["totalValue"] = this.recalculateTotal(newTempStateCLI)
        return newTempStateCLI

      case 'CHANGE_VISIT_TYPE':
        visitType = state.visitTypes.filter(vt => vt.id == action.selectedVisitType)[0]
        newVisibleProducts = this.determineVisibleProducts(state.products, visitType)
        newLineItems = this.initializeLineItems(newVisibleProducts, this.props.lineItems, visitType)

        newState = {
          ...state,
          selectedVisitType: visitType,
          visibleProducts: this.determineVisibleProducts(state.products, visitType),
          lineItems: newLineItems
        }

        return newState

      case 'CHANGE_PAYMENT_TYPE':
        newState = {
          ...state,
          selectedPaymentType: action.selectedPaymentType
        }
        return newState

      default:
        return state
    }
  }

  initializeLineItems = (products, lineItems, selectedVisitType) => {
    products = products.filter(product => product.product_company_id == selectedVisitType.product_company_id)
    return products.map(product => {
      lineItems = lineItems == null ? [] : lineItems
      let foundLineItem = lineItems.find(li => li.product_id == product.id)
      const nowString = moment(new Date()).format('YYYYMMDDhhmmss')
      if (foundLineItem) {
        return {
          id: foundLineItem.id,
          selectedProduct: product,
          stock: foundLineItem.stock,
          gift: foundLineItem.gift,
          quantity: foundLineItem.quantity,
          invoiced: foundLineItem.invoiced,
          discount: foundLineItem.discount
        }
      } else {
        return {
          id: `${nowString}${product.id}`,
          selectedProduct: product,
          stock: "0",
          gift: "0",
          quantity: "0",
          invoiced: "0",
          discount: "0"
        }
      }
    }).sort((a, b) => a.selectedProduct.name > b.selectedProduct.name ? 1 : -1)
  }

  augmentVisitTypes = (visitTypes) => {
    const blankVisitType = { id: "", name: "", product_company_id: "" }
    return [
      blankVisitType,
      ...visitTypes
    ]
  }

  recalculateTotal = (state) => {
    return (this.lineItemsTotal(state.lineItems) / 100).toFixed(2)
  }

  lineItemsTotal = (lineItems) => {
    if (lineItems.length == 0) return 0
    return lineItems.reduce((acc, item) => {
      let discount = "0"
      let quantity = "0"
      let price_cents = item.selectedProduct.price_cents
      let temp = price_cents - (price_cents * (parseInt(item.discount) / 100))
      return (acc + temp * parseInt(item.quantity))
    }, 0)
  }

  determineVisibleProducts = (products, visitType) => {
    if (visitType == undefined || visitType.id == "") return []
    return products.filter(prod => prod.product_company_id == visitType.product_company_id)
  }

  determineSelectedVisitType = (visitTypes, id) => {
    if (!id) return { id: "", name: "" }
    return visitTypes[visitTypes.findIndex(vt => vt.id == id)]
  }

  getLineItemsWithoutCurrent = (lineItems, id) => {
    return [...lineItems.filter(el => el.id !== id)]
  }

  findLineItem = (lineItems, id) => {
    return lineItems.find(lineItem => lineItem.id == id)
  }

  store = () => {
    return createStore(this.storeState);
  }

  render = () => {
    return (
      <Provider store={this.store()}><VisitSubForms /></Provider>
    );
  }
}

export default VisitApp
